import { AUTH_CALLBACK_PATH } from './config'

let stagedAssertion: string | null = null

/**
 * Captures the one-time assertion before React renders and immediately removes
 * the URL fragment. Call this once from the application entry point before
 * createRoot(). The value only lives in this module's memory.
 */
export function stageAssertionFromLocation(): string | null {
  if (
    typeof window === 'undefined' ||
    window.location.pathname.replace(/\/+$/, '') !== AUTH_CALLBACK_PATH
  ) {
    return null
  }

  const rawHash = window.location.hash.startsWith('#')
    ? window.location.hash.slice(1)
    : window.location.hash

  // A repeated bootstrap/HMR call must not erase an assertion already staged
  // by the first call after its fragment was removed.
  if (!rawHash) return stagedAssertion

  const assertion = new URLSearchParams(rawHash).get('assertion')?.trim() || null

  window.history.replaceState(
    window.history.state,
    '',
    window.location.pathname + window.location.search,
  )

  stagedAssertion = assertion
  return stagedAssertion
}

export function getStagedAssertion(): string | null {
  return stagedAssertion
}

export function clearStagedAssertion(assertion?: string | null): void {
  if (assertion && stagedAssertion !== assertion) return
  stagedAssertion = null
}
